import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import card1 from '../assets/images/account-bid/card1.png';
import card2 from '../assets/images/account-bid/card2.png';
import card3 from '../assets/images/account-bid/card3.png';
import card4 from '../assets/images/account-bid/card4.png';
import win from '../assets/images/account-bid/winning-bid.png';
import outbid from '../assets/images/account-bid/outbid.png';
import Header from './Header';
import Footer from './Footer';

class AccountActivityBid extends Component {
    WinBid = () => {
        this.props.history.push('/WinBid');
    }
    OutBid = () => {
        this.props.history.push('/OutBid');
    }
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* MArketplace area start */}
                <div className="buyer-activity-heading">
                    <h1>Account Activity</h1>
                    <h1>CURATED</h1>
                    <div className="container-fluid buyer-activity">
                        <div className="row head justify-content-between">
                            <h4></h4>
                            <h4>Sort By <i className="fa fa-arrow-up"></i><i className="fa fa-arrow-down"></i></h4>
                        </div>
                        <div className="container-fluid buyer-activity-detail mb-5 h-100">
                            <div className="row h-100">
                                <aside className="col-12 col-md-2 p-0">
                                    <nav className="navbar navbar-expand flex-md-column flex-row align-items-start">
                                        <div className="collapse navbar-collapse">
                                            <ul>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivityBuyer">Purchases</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivitySales">Sales</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivityOfferReceived">Offers Received</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0" to="/AccountActivityOfferMade">Offers Made</Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className="nav-link pl-0 active" to="/AccountActivityBid">BIDS</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </nav>
                                </aside>
                                <main className="col">
                                    <nav className="marketplace-card">
                                        <div className="most-popular row">
                                            <div className="card">
                                                <Link to="/WinBid">
                                                    <img src={card1} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/WinBid">
                                                        <h3>Flower Face - Dusk</h3>
                                                    </Link>
                                                    <h5><span>HIGHEST BID</span>&emsp;$10,000<img src={win} alt="win" className="bidIcon" /> </h5>
                                                    <button onClick={this.WinBid}>INCREASE BID</button>
                                                    <p className="card-text green"><span>ENDING&emsp;<strong>2h 5m 3s</strong></span>BID RANK 3/15</p>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <Link to="/WinBid">
                                                    <img src={card2} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/WinBid">
                                                        <h3>The Circle #14</h3>
                                                    </Link>
                                                    <h5><span>HIGHEST BID</span>&emsp;$10,000<img src={win} alt="win" className="bidIcon" /> </h5>
                                                    <button onClick={this.WinBid}>INCREASE BID</button>
                                                    <p className="card-text green"><span>ENDING&emsp;<strong>1d 2h</strong></span>&emsp;&emsp;&emsp;&emsp;WINNING</p>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <Link to="/WinBid">
                                                    <img src={card3} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/WinBid">
                                                        <h3>Artwork Title #12</h3>
                                                    </Link>
                                                    <h5><span>HIGHEST BID</span>&emsp;$500<img src={win} alt="win" className="bidIcon" /> </h5>
                                                    <button onClick={this.WinBid}>INCREASE BID</button>
                                                    <p className="card-text green"><span>ENDING&emsp;<strong>6h 5m</strong></span>&emsp;&emsp;&emsp;&emsp;WINNING</p>
                                                </div>
                                            </div>
                                            <div className="card">
                                                <Link to="/OutBid">
                                                    <img src={card4} className="card-img-top" alt="" />
                                                </Link>
                                                <div className="card-body">
                                                    <Link to="/OutBid">
                                                        <h3>Ritual One - Stone #9</h3>
                                                    </Link>
                                                    <h5><span>HIGHEST BID</span>&emsp;$8,000<img src={outbid} alt="outbid" className="bidIcon" /> </h5>
                                                    <button onClick={this.OutBid}>INCREASE BID</button>
                                                    <p className="card-text1"><span>ENDING&emsp;<strong>2d</strong></span>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;OUTBID</p>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </main>
                            </div>
                        </div>
                    </div>
                    {/* Footer area start */}
                    <Footer />
                    {/* Footer area end */}
                </div>
                {/* MArketplace area end */}
            </div>
        )
    }
};

export default AccountActivityBid;